import axios from 'axios';

// Admin management of a customer's address book (P-ADMIN-1). Auth (admin cookie
// + X-App header) is applied by the app's global axios defaults, same as the
// other customer-profile calls.
const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/admin/customer-address`;

const getAddresses = (customerId) => axios.get(`${BASE}/customer/${customerId}`);
const createAddress = (customerId, data) => axios.post(`${BASE}/customer/${customerId}`, data);
const updateAddress = (addressId, data) => axios.put(`${BASE}/${addressId}`, data);
const deleteAddress = (addressId) => axios.delete(`${BASE}/${addressId}`);
const setDefaultAddress = (addressId) => axios.patch(`${BASE}/${addressId}/set-default`);

const CustomerAddressService = {
  getAddresses,
  createAddress,
  updateAddress,
  deleteAddress,
  setDefaultAddress,
};

export default CustomerAddressService;
